import React, { useState, useEffect } from 'react';
import FeedbackGrid from './FeedbackGrid';
import HeaderFilter from './HeaderFilter';
import { Paper } from '@material-ui/core';
import Filters from '../../Components/Filters/Filters';
import { filterSessionGetData } from '../../Utils/apiServices';
import KenLoader from '../../Components/KenLoader';
import KenSnackbar from '../../Components/KenSnackbar/index';
const FeedbackSetupMaster = ({ feedbackName, value }) => {
  const [SelectedID, setSelectedID] = useState('');
  const [sessionData, setSessionData] = useState([]);
  const [CourseID, setCourseID] = useState('');
  const [loading, setLoading] = useState(false);
  const [reCallAPI, setReCallAPI] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  useEffect(() => {
    if (SelectedID) {
      setLoading(true);
      filterSessionGetData(SelectedID)
        .then((res) => {
          setSessionData(res.data);
          setReCallAPI(false);
          setLoading(false);
        })
        .catch((error) => {
          handleSnackbarOpen('error', error.message);
        });
    }
  }, [SelectedID, reCallAPI]);
  return (
    <>
      <Paper>
        <KenSnackbar
          message={snackbarMessage}
          severity={snackbarSeverity}
          autoHideDuration={4000}
          open={openSnackbar}
          handleSnackbarClose={handleSnackbarClose}
          position="Bottom-Right"
        />
        {value === 0 && (
          <Filters
            term={true}
            setSelectedID={setSelectedID}
            setCourseID={setCourseID}
            CourseVersion={true}
            sessionFeedback={true}
            courseoff={true}
            setSessionData={setSessionData}
          />
        )}
      </Paper>
      {loading && <KenLoader />}

      <FeedbackGrid
        SelectedID={SelectedID}
        value={value}
        sessionData={sessionData}
        CourseID={CourseID}
        setReCallAPI={setReCallAPI}
      />
    </>
  );
};

export default FeedbackSetupMaster;
